export const TEXT = 'text';